/* eslint-disable no-case-declarations */
import { each, indexOf } from 'lodash'
import { KPIWidgetsState, KPIWidgetsMessage } from './types'

export const getPieInitialState = (): KPIWidgetsState => {
    return {
        line: {
            bufferEvents: [],
            fields: [],
            xAxis: {
                baseline: { min: undefined, max: undefined, end: undefined },
                realTime: { min: undefined, max: undefined, end: undefined }
            },
            by: '',
            endHistory: false,
            events: {}
        },
        pie: {
            bufferEvents: [],
            fields: [],
            by: '',
            endHistory: false,
            events: {}
        },
        endHistory: false
    }
}
export const reducer: WidgetReducerType<KPIWidgetsState, KPIWidgetsMessage> = (
    state = getPieInitialState(),
    message
) => {
    // test for initialState calls
    const charts = ['line', 'pie']
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    function onSpanChanged({ events, isBaseline }): void {
        const begin = events.begin

        const end = events.end

        const xAxis = state.line.xAxis

        const currentMax = xAxis.realTime.max

        const currentMin = xAxis.realTime.min

        const currentEnd = xAxis.realTime.end

        const currentBaselineMin = xAxis.baseline.min

        const currentBaselineMax = xAxis.baseline.max

        // do not walk backwards
        if (!isBaseline && typeof currentEnd != 'undefined' && end < currentEnd) return

        const min = begin

        let max = end

        if (max - min < 1000) {
            // 'now' or 'none'
            max = min + 60 * 1000
        } else if (!isBaseline) {
            // add 1 minute at the right
            // Add 10% for future placeholder when in real time
            // if (isRealTime(layer)) max += (max - min) / 10
        } else if (currentMin && currentMax) {
            max = min + (currentMax - currentMin)
        }

        const extremes = { min: min, max: max, end: end }

        if (isBaseline) {
            state.line.xAxis.baseline = extremes
        } else {
            state.line.xAxis.realTime = extremes

            // fix baseline extremes if baseline span event arrived early
            if (currentBaselineMax && currentBaselineMin && currentBaselineMax - currentBaselineMin > max - min) {
                state.line.xAxis.baseline.max = currentBaselineMin + (max - min)
            }
        }
    }

    switch (message.type) {
        case 'start':
            const chart = message.events.select.indexOf('Hole Depth') >= 0 ? 'line' : 'pie'

            each(message.events.select, function (field) {
                if (
                    field !== 'timestamp' &&
                    field !== 'chart' &&
                    indexOf(state[chart].fields, field) < 0 &&
                    !field.startsWith('__') &&
                    field !== 'rig_name'
                ) {
                    state[chart].fields.push(field)
                }
            })

            if (message.events.group.length) {
                state[chart].by =
                    message.events.select.indexOf('Hole Depth') >= 0
                        ? message.events.select[0]
                        : message.events.group[0]
            }
            break
        case 'event':
            const separeteChartEvents = {
                line: message.events.filter(event => event?.chart === 'line'),
                pie: message.events.filter(event => event?.chart === 'pie')
            }

            for (const chart of Object.keys(separeteChartEvents).map(key => key)) {
                const temp = []
                let _type = null
                for (const event of separeteChartEvents[chart]) {
                    const __type = event.__assetName
                    _type = __type

                    if (state[chart]?.fields.length === 0) {
                        state[chart].fields = Object.keys(event)?.filter(
                            field => field !== 'timestamp' && field !== 'chart' && !field.startsWith('__')
                        )
                    }
                    if (!state[chart].events[__type]) {
                        Object.assign(state[chart]?.events, { [__type]: [] })
                    }

                    if (chart === 'line') {
                        state[chart].events[__type].push(event)
                    } else {
                        temp.push(event)
                    }
                }
                if (temp.length > 0 && _type) {
                    state.pie.events[_type] = temp
                }
            }

            break
        case 'endHistory':
            for (const chart of charts) {
                state = {
                    ...state,
                    endHistory: true,
                    [chart]: {
                        ...state[chart],
                        events: { ...state[chart].events },
                        endHistory: true,
                        bufferEvents: []
                    }
                }
            }
            break
        default:
            return state
    }

    return state
}
